export { default } from './search-results.component';
